<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card :loading="loading">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{ feedbacks.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text class="#f4f5f7">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div v-html="editorData"></div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      feedbacks: {},
      editorData: "",
    };
  },

  methods: {
    getData() {
      this.loading = true;
      this.$axios
        .get("/cms?identifier=refund_policy")
        .then((response) => {
          this.feedbacks = response.data[0] || { title: "Refund Policy" };
          this.editorData = this.feedbacks.content || "";
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
